export const topMenuHeight = 48;
export const leftMenuWidth = 68;
export const mainLayoutPadding = 16;
export const organizationLeftMenuWidth = 280;
export const clusterHeaderHeight = 72;
export const actionMenuWidth = 50;
export const fixedOverviewActionMenuHeight = 74;